import {
  SET_LOADING_DATA,
  SET_LOADING_SELECTS,
  SET_ORDER,
  SET_ORDERBY,
  SET_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_PER_PAGE,
  GET_LIST_ALL_AUDIT_USER_REQUEST,
  GET_LIST_ALL_AUDIT_USER_SUCCESS
} from './audit-user-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingSelects = (loading: Boolean) => {
  return {
    type: SET_LOADING_SELECTS,
    loading
  };
};

export const getAllAuditUserRequest = () => {
  return {
    type: GET_LIST_ALL_AUDIT_USER_REQUEST
  };
};

export const getAllAuditUserSuccess = payload => {
  return {
    type: GET_LIST_ALL_AUDIT_USER_SUCCESS,
    payload
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setRowsCount = (rowsCount: Number) => {
  return {
    type: SET_ROWS_COUNT,
    rowsCount
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: (string | boolean)[]) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};
